import {isUndefined, assign} from 'lodash-es'

let cacheMap = {
  i18Map: {},
  objectApiNameMap: {}
}
window.paas_cacheMap = cacheMap
const _axios = window.Vue.prototype.axios

/**
 * 函数getI18nData: 获取i18全量数据
 *  参数: objectApiName=> 主对象
 *  region: ===2时，预置对象
 *  subObjectApiNames: 当前主对象对应全部从对象ObjectApiName
 */
export const getI18nData = async function (
  objectApiName,
  region,
  subObjectApiNames = []
) {
  // 命中缓存,取缓存
  let result
  if (!isUndefined((result = _getCache(objectApiName)))) {
    return result
  }

  try {
    const tasks = [_getRequest(objectApiName)]
    if (region === 2) {
      tasks.push(_getRequest(objectApiName, region))
    }
    const [tenantI18, platformI18] = await _axios.all(tasks)
    result = assign({}, _formatting(tenantI18), _formatting(platformI18))
    const _key = `${objectApiName}_${window.fe.language}`
    cacheMap.i18Map[_key] = result
    cacheMap.objectApiNameMap[_key] = _key
    subObjectApiNames.forEach(key => {
      cacheMap.objectApiNameMap[`${key}_${window.fe.language}`] = _key
    })
    return result
    // _axios.all(tasks).then(
    //   _axios.spread((tenantI18, platformI18) => {
    //     // 如果有自定义的合并
    //     result = assign({}, _formatting(tenantI18), _formatting(platformI18))
    //     const _key = `${objectApiName}_${window.fe.language}`
    //     cacheMap.i18Map[_key] = result
    //     cacheMap.objectApiNameMap[_key] = _key
    //     subObjectApiNames.forEach(key => {
    //       cacheMap.objectApiNameMap[`${key}_${window.fe.language}`] = _key
    //     })
    //     return result
    //   })
    // )
  } catch (error) {
    console.log('err', error)
  }
}

/**
 * 函数: getI18: 获取国际化数据
 * 参数:
 * objectApiName: 当前对象 ObjectApiName(主从都可以)
 * code: 当前i18code
 */

export function getI18 (objectApiName, code) {
  const i18Data = _getCache(objectApiName)
  return isUndefined(code) ? i18Data : i18Data?.[code]
}

// 取缓存
function _getCache (objectApiName) {
  const {objectApiNameMap, i18Map} = cacheMap
  const key = `${objectApiName}_${window.fe.language}`
  return !isUndefined(objectApiNameMap[key])
    ? i18Map[objectApiNameMap[key]]
    : undefined
}

// 获取接口
function _getRequest (objectApiName, region) {
  return _axios.get(_getApiUrl(objectApiName, region))
}

// 获取url
function _getApiUrl (objectApiName, region = 1) {
  const {i18nOssHost, purchaserId, language} = window.fe
  const apiMaps = {
    1: `${i18nOssHost}aPaas/${purchaserId}/${objectApiName}-all/${language}.json`,
    2: `${i18nOssHost}aPaas/${objectApiName}-all/${language}.json`
  }
  return apiMaps[region]
}

// 格式化返回结果 可能是字符串
function _formatting (payload) {
  if (isUndefined(payload?.data)) {
    return {}
  }
  if (typeof payload.data === 'string') {
    return () => payload.data
  }
  return payload.data
}
